import { Audio, Images, Tweens } from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';

export default class CounterText extends Phaser.GameObjects.Container {
  constructor(scene, textTemplate, size, color, sprite, spriteSheet) {
    super(scene);

    this.text = null;
    this.size = null;
    this.color = null;
    this.textLabel = null;
    this.value = null;
    this.spriteBackground = null;
    this.animateNumbers = false;

    if (spriteSheet && sprite) {

      // this.spriteBackground = new createjs.Sprite(spriteSheet, sprite);
      this.spriteBackground = Images.addImage(0, 0, sprite, this);
    }
    else if (sprite) {

      // this.spriteBackground = new createjs.Bitmap(game.assets.getAsset(sprite));
      this.spriteBackground = Images.addImage(0, 0, sprite, this);
    }

    this.textTemplate = textTemplate;
    this.size = size;
    this.color = color;

    this.textLabel = this.scene.add.text(0, 0, '100', { fontFamily: FontKeys.odin, color, fontSize: `${size}pt`, align: 'center' }).setOrigin(.5);
    this.textLabel.y += this.textLabel.height / 2;

    // this.textLabel = new createjs.Text('', `${size}pt odin`, color);
    // const result = this.textTemplate.replace('_VALUE_', `${this.value}`);
    // this.textLabel.text = this.value;

    this.add(this.textLabel);
  };

  addValue(value) {

    const newValue = this.value + value;
    this.setValue(newValue);
  }

  // if value changes, update the textLabel

  setValue(value) {

    this.value = value;

    this.textLabel.text = value;

    // this.textLabel.width += 10;

    if (this.animateNumbers) {
      this.textLabel.setPadding(15,15);
      this.textLabel.setShadow(0, 0, '#000', 15, true);

      this.scene.tweens.addCounter({
        from: 0,
        to: 6,
        duration: 500,
        onUpdate: (tween) => {
          const value = tween.getValue();
          this.textLabel.setShadowOffset(value, value);
        }
      });

      this.scene.tweens.addCounter({
        from: 34,
        to: 85,
        duration: 500,
        onUpdate: (tween) => {
          this.textLabel.setFontSize(`${tween.getValue()}pt`);
        },
        onComplete: () => {
          this.scene.tweens.addCounter({
            from: 6,
            to: 0,
            duration: 200,
            onUpdate: (tween) => {
              const value = tween.getValue();
              this.textLabel.setShadowOffset(value, value);
            }
          });

          this.scene.tweens.addCounter({ from: 85,
            to: 34,
            duration: 200,
            onUpdate: (tween) => {
              this.textLabel.setFontSize(`${tween.getValue()}pt`);
            },
            onComplete: () => {
              this.textLabel.setShadow(0, 0, '#000', 0, false);
            } });
        }
      });
    }
  }

  countToValue(value) {

    let cumulativeTime = 0;

    for (let i = this.value + 1; i < value + 1; i++) {

      // createjs.Tween.get(this)
      //   .wait(cumulativeTime)
      //   .call(this.setValue,[i],this);

      this.scene.time.addEvent({ delay: cumulativeTime, callback: () => {this.setValue(i);} });

      cumulativeTime += 50;

    }

    return cumulativeTime;

  }

  countDownToValue(value) {

    let cumulativeTime = 0;

    for (let i = this.value; i > value - 1; i--) {

      // createjs.Tween.get(this)
      //   .wait(cumulativeTime)
      //   .call(this.setValue,[i],this);

      this.scene.time.addEvent({ delay: cumulativeTime, callback: () => {this.setValue(i);} });

      cumulativeTime += 50;

    }

    // hack -- the score won't go to 0 at times
    // createjs.Tween.get(this)
    //   .wait(cumulativeTime)
    //   .call(this.setValue,[0],this);

    this.scene.time.addEvent({ delay: cumulativeTime, callback: () => {this.setValue(0);} });

    return cumulativeTime;
  }

  removeTextShadow () {
    this.textLabel.shadow = null;
  }

  getValue () {
    return this.value;
  }

  getValueString () {
    return this.textLabel.text;
  }

  doClick() {

    if (!this.enabled) { }

    Audio.playOneShot('click', this.scene);

  };
}